import styled from '@emotion/styled'
import { colors, metrics, fonts } from 'component-library/__styling/settings'
import { calcRem } from 'component-library/__styling/style-functions'

export const StyledSite = styled('div')({
    fontFamily: fonts.thewest.body,
    fontSize: metrics.thewest.baseFontSize,
    color: colors.black,
    lineHeight: 1.5,
})

export const SiteFullWidthAd = styled('div')({
    width: '100%',
    background: colors.thewest.greyErmine,
})

export const SiteHeaderAd = styled('div')({
    marginTop: calcRem(-20),
})
